import { createMuiTheme } from "@material-ui/core";

export const sologenicTheme = createMuiTheme({
  colors: {
    background: {
      main: "#262626",
      fore: "#2E2E2E",
      lightFore: "#373737",
      inactive: "#454545",
      active: "#D81D3C",
      secondary: "#0D0D0D",
      redGradient: "#A81D34",
      activeOpaque: "#3E2B2E",
      stepActive: "#D81D3C",
      rightSideSignUp: "#262626",
      verificationHeader: "#0D0D0D",
      mobDashBtn: "#D81D3C",
    },
    text: {
      primary: "#FFFFFF",
      secondary: "#C3C3C3",
      tertiary: "#828282",
      textOnRed: "#FFFFFF",
      inactiveText: "#C3C3C3",
      secondary2: "#C3C3C3",
    },
    buttons: {
      green: "#D81D3C",
      red: "#FF9B9B",
      blue: "#009BE5",
      buy: "#9BFF9F",
      sell: "#FF9B9B",
      firstScreen: "#9BFF9F",
    },
    misc: {
      yellow: "#E0CE67",
      black: "#0D0D0D",
      blue: "#5BACD8",
      etfs: "#1DD84F",
      dividers: "#828282",
      white: "#FFFFFF",
      red: "#BE4545",
      orange: "#F2A252",
      pink: "#F2B1B1",
      green: "#A8F0AB",
      _blue: "#FFFFFF",
      fail: "#F2B1B1",
      success: "#A8F0AB",
      activeDoc: "#D81D3C",
      signOut: "#D81D3C",
    },
  },
  defaults: {
    shadow: "0 4px 12px #00000029",
    roundBtn: {
      minWidth: 120,
      height: 40,
      minHeight: 40,
      borderRadius: 20,
      border: "1px solid transparent",
      textTransform: "capitalize",
      fontSize: 16,
      boxShadow: "0 4px 8px #00000029",
      transition: ".3s",
      cursor: "pointer",
      // fontFamily: "Titillium Web",
      fontWeight: 600,
      color: "#FFFFFF",
      "&:hover": {
        opacity: 0.7,
      },
      "&:disabled": {
        background: "#454545",
        opacity: 1,
        cursor: "not-allowed",
        color: "#262626",
        boxShadow: "none",
      },
      "&:focus, &:active": {
        outline: "none",
      },
    },
    squareBtn: {
      minWidth: 120,
      height: 48,
      minHeight: 40,
      borderRadius: 2,
      border: "1px solid transparent",
      textTransform: "uppercase",
      fontSize: 16,
      boxShadow: "0 4px 8px #00000029",
      transition: ".3s",
      cursor: "pointer",
      // fontFamily: "Titillium Web",
      fontWeight: 600,
      "&:hover": {
        opacity: 0.7,
      },
      "&:disabled": {
        background: "#454545",
        opacity: 1,
        cursor: "not-allowed",
        color: "#262626",
        boxShadow: "none",
      },
      "&:focus, &:active": {
        outline: "none",
      },
    },
    walletBtn: {
      border: "none",
      height: 32,
      width: 180,
      background: "#2E2E2E",
      borderRadius: 4,
      boxShadow: "0 4px 8px #00000029",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#C3C3C3",
      transition: ".3s",
      cursor: "pointer",
      "& svg": {
        marginLeft: 8,
        fontSize: 14,
      },
      "&:hover": {
        opacity: 0.7,
      },
      "&:focus, &:active": {
        outline: "none",
      },
    },
    input: {
      height: 48,
      background: "#454545",
      borderRadius: 4,
      boxShadow: "0 4px 8px #00000029",
      color: "#828282",
      fontSize: 14,
      width: "100%",
      maxWidth: 320,
      paddingLeft: 16,
      border: "1px solid transparent",
      // fontFamily: "Titillium Web",
      "&:focus, &:active": {
        outline: "none",
      },
    },
    link: {
      textDecoration: "none",
      fontWeight: 700,
      color: "#FFFFFF",
      "&:hover": {
        textDecoration: "underline",
      },
    },
  },
});
